const generateURLQuery = (params: object) => {
  return Object.entries(params)
    .reduce((acc: string[], [key, value]) => {
      return value ? [...acc, `${key}=${value}`] : acc;
    }, [])
    .join(',');
};

export default generateURLQuery;
